const fr = {
  nav: {
    home: 'Accueil',
    myNotes: 'Mes Notes',
    viewMode: 'MODE DE VUE',
    editorView: 'Vue Éditeur',
    adaptedView: 'Vue Adaptée',
    contentType: 'TYPE DE CONTENU',
    mindmaps: 'Cartes Mentales',
    flashcards: 'Flashcards',
    podcast: 'Podcast',
    studyNotes: "Fiches d'étude",
    upgrade: 'Passer sur Pro',
    upgradeMessage: 'Passez à un plan supérieur pour débloquer les limites.',
    settings: 'Paramètres',
    connection: 'Connexion',
    signOut: 'Se déconnecter',
  },
  home: {
    welcome: 'Prêt à apprendre ?',
    visualProfile: '🎨 Tu es un apprenant visuel. Prêt à transformer tes cours ?',
    auditoryProfile: '🎧 Tu es un apprenant auditif. Transforme tes cours en podcasts.',
    readingProfile: '📖 Tu es un apprenant lecteur-scripteur. Organise tes idées.',
    kinestheticProfile: "🤲 Tu es un apprenant kinesthésique. Passe à l'action !",
    blankNote: 'Note Vierge',
    startFromScratch: 'Commencer de zéro',
    tagline: "Tu fais l'effort, on gère les outils.",
    importFailed: 'Import échoué',
    importInProgress: 'Import en cours',
    importPreparingMessage: 'Nous préparons votre {label}. Cela peut prendre quelques secondes.',
    close: 'Fermer',
    limitReachedMessage: "Vous avez atteint la limite de 5 importations sur le plan gratuit. Passez à un plan supérieur pour continuer.",
    fileTooLargeError: "Le fichier est trop volumineux ou complexe pour être traité. Essayez un document plus court ou divisez-le en parties plus petites.",
    importFailedPrefix: 'Import échoué : ',
    unexpectedError: 'Une erreur inattendue est survenue.',
    unsupportedFormat: 'Format de fichier non supporté.',
    sourceType: {
      audio: 'audio',
      pdf: 'fichier',
      image: 'image',
      doc: 'document',
      link: 'lien',
      youtube: 'lien YouTube',
    },
  },
  import: {
    audioTriggerTitle: 'Enregistrer / Importer audio',
    audioTriggerDesc: 'Microphone et fichiers audio',
    audioTitle: 'Audio',
    audioSubtitle: 'Enregistrez votre voix ou importez des fichiers audio',
    startRecording: "Démarrer l'enregistrement",
    startRecordingDesc: 'Capturez votre cours en temps réel depuis le microphone',
    importAudioFiles: 'Importer des fichiers audio',
    importAudioFormats: 'MP3, WAV, M4A, OGG, FLAC…',
    dragDropAudio: 'Glissez-déposez un ou plusieurs fichiers audio ici',
    addAnotherAudio: 'Ajouter un autre audio',
    reset: 'Réinitialiser',
    confirmImport: "Confirmer l'import ({count})",
    audioFileFallback: 'Fichier audio',
    recordingInProgress: 'Enregistrement en cours',
    stopRecording: 'Arrêter',
    importFile: 'Importer un fichier',
    importFileSubtitle: 'Choisissez des documents depuis votre ordinateur',
    dragDropFiles: 'Glissez-déposez des fichiers ici',
    addAnotherFile: 'Ajouter un autre fichier',
    confirmFileImport: "Confirmer l'import ({count})",
    supportedFormats: 'PDF, Word, Images',
    videoLink: 'Lien vidéo',
    videoLinkSubtitle: "Collez l'URL d'une vidéo YouTube à analyser",
    videoPlaceholder: 'https://www.youtube.com/watch?v=...',
    importLink: 'Importer un lien',
    importLinkSubtitle: "URL d'un site web pour en extraire le contenu",
    linkPlaceholder: 'https://...',
    analyze: 'Analyser',
    cancel: 'Annuler',
    record: 'Enregistrer',
    processing: 'Traitement…',
    upload: 'Importer',
    videoLinkHint: 'Appuyez sur Entrée ou cliquez sur "Confirmer"',
    confirmLink: 'Confirmer',
  },
  app: {
    loadingWorkspace: 'Chargement de votre espace de travail…',
  },
  notes: {
    loadingTitle: 'Chargement de votre note',
    loadingSubtitle: 'Cela peut prendre de 1 à plusieurs minutes pour du contenu long ou complexe.',
    assistantTitle: 'Assistant Plynote',
    openAssistant: "Ouvrir l'assistant Plynote",
    closeAssistant: "Fermer l'assistant Plynote",
    chatFullscreen: 'Plein écran',
    chatExitFullscreen: 'Quitter le plein écran',
    chatAnswering: "L'IA répond...",
    chatWelcomeGreeting: 'Salut, {name}',
    chatWelcomeMessage: 'Tu peux me poser toutes tes questions ici.',
    askQuestion: 'Posez votre question...',
    lastUpdate: 'Dernière mise à jour :',
    date: {
      today: "Aujourd'hui - {time}",
      yesterday: 'Hier - {time}',
      unknown: 'Date inconnue',
    },
    sort: {
      label: 'Trier :',
      mostRecent: 'Les plus récentes',
      oldest: 'Les plus anciennes',
      oldestToNewest: 'Des plus anciennes aux plus récentes',
      newestToOldest: 'Des plus récentes aux plus anciennes',
    },
    sections: {
      today: "Aujourd'hui",
      last30days: '30 derniers jours',
      earlier: 'Plus anciennes',
    },
    search: {
      placeholder: 'Rechercher des notes par nom...',
    },
    loading: 'Chargement des notes...',
    singleNote: 'note',
    pluralNotes: 'notes',
    empty: {
      signIn: 'Connectez-vous pour voir vos notes.',
      noNotes: 'Aucune note trouvée pour le moment.',
      noMatch: 'Aucune note ne correspond à votre recherche.',
    },
    menu: {
      title: 'Actions sur la note',
      newName: 'Nouveau nom',
      ok: 'OK',
      actions: 'Actions',
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette note ? Cette action est irréversible.",
    },
    untitled: 'Note sans titre',
    adaptedView: {
      emptyTitle: 'Format pas encore généré',
      emptyDescriptionWithContent: 'Ce format n’a pas encore été généré pour cette note. Lancez la génération pour afficher cette vue.',
      emptyDescriptionWithoutContent: 'Aucun contenu source détecté. Ajoutez ou chargez d’abord le contenu, puis lancez la génération.',
      noContentFallback: 'Aucun contenu source détecté. Ajoutez ou chargez d’abord le contenu, puis lancez la génération.',
      dismissErrorLabel: 'Masquer l’erreur',
      generateButton: 'Générer le format actuel',
      regenerateButton: 'Régénérer ce contenu',
      deepMode: 'Complet',
      summarizedMode: 'Résumé',
    },
  },
  payment: {
    chooseSubscription: 'Choisir un abonnement',
    selectPlan: 'Sélectionnez un plan pour continuer sur Plynote.',
    mustBeSignedIn: 'Vous devez être connecté pour vous abonner.',
    loadingPlans: 'Chargement des plans Stripe...',
    mostPopular: 'Le plus populaire',
    save: 'Économisez {pct}%',
    perWeek: '/semaine',
    currentPlan: 'Plan actuel',
    redirecting: 'Redirection...',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    featureUnlimitedFormats: 'Adaptations de format illimitées',
    featureUnlimitedChat: 'Messages de chat illimités',
    featureUnlimitedUploads: 'Importations illimitées',
    featureEmailSupport: 'Support par email',
    chooseMonthly: 'Choisir Mensuel',
    chooseYearly: 'Choisir Annuel',
    billedYearly: 'Facturé annuellement {amount}',
    billedMonthly: 'Facturé mensuellement {amount}',
  },
  settings: {
    title: 'Paramètres',
    subtitle: 'Paramètres du compte, apparence et sécurité de session.',
    redirectingToStripe: 'Redirection vers Stripe...',
    redirectingDesc: 'Vous allez être redirigé vers la page de paiement sécurisée de Stripe.',
    loading: 'Chargement de vos paramètres...',
    loadingDesc: 'Nous récupérons vos informations de compte et votre abonnement actuel.',
    stripeRedirectFailed: 'Échec de la redirection Stripe',
    retrySubscriptions: 'Réessayer depuis les abonnements',
    accountInfo: 'Informations du compte',
    accountInfoDesc: 'Vos informations de profil principales.',
    username: "Nom d'utilisateur",
    email: 'Email',
    notProvided: 'Non renseigné',
    currentPlan: 'Plan actuel',
    currentPlanDesc: 'Consultez votre abonnement actif, mettez à niveau ou annulez.',
    loadingPlan: 'Chargement de votre plan...',
    planLabel: 'Plan',
    statusLabel: 'Statut',
    priceLabel: 'Prix',
    activeSubscription: 'Abonnement actif',
    noSubscription: 'Aucun abonnement',
    upgrade: 'Mettre à niveau',
    manageSubscription: "Gérer l'abonnement",
    perMonth: '/mois',
    perYear: '/an',
    theme: 'Thème',
    themeDesc: "Choisissez l'apparence de l'application.",
    themeLight: 'Clair',
    themeDark: 'Sombre',
    themeSystem: 'Système',
    language: 'Langue',
    languageDesc: "Choisissez la langue de l'interface.",
    languageEn: 'English',
    languageFr: 'Français',
    session: 'Session',
    sessionDesc: 'Déconnectez-vous proprement de votre compte.',
    signOut: 'Se déconnecter',
  },
  auth: {
    loginSubtitle: 'Accédez à vos notes et adaptations personnalisées.',
    signupSubtitle: 'Rejoignez Plynote et commencez à apprendre autrement.',
    checkEmail: 'Vérifiez votre email',
    verificationSent: 'Un code de vérification a été envoyé à',
    verifying: 'Vérification...',
    verifyCode: 'Vérifier le code',
    resendIn: 'Renvoyer dans {sec}s',
    resendCode: 'Renvoyer le code',
    back: 'Retour',
    newPassword: 'Nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    signIn: 'Se connecter',
    createAccount: 'Créer un compte',
    chooseNewPassword: 'Choisissez un nouveau mot de passe sécurisé pour votre compte.',
    enterEmailForReset: 'Entrez votre adresse email pour recevoir un lien de réinitialisation.',
    newPasswordPlaceholder: 'Nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmer le mot de passe',
    updating: 'Mise à jour...',
    changePassword: 'Changer le mot de passe',
    sending: 'Envoi...',
    sendLink: 'Envoyer le lien',
    linkSent: 'Lien envoyé — vérifiez votre boîte de réception.',
    continueWithGoogle: 'Continuer avec Google',
    or: 'OU',
    signInTab: 'Connexion',
    signUpTab: 'Inscription',
    passwordPlaceholder: 'Mot de passe',
    signingIn: 'Connexion...',
    forgotPassword: 'Mot de passe oublié ?',
    fullNamePlaceholder: 'Nom complet',
    usernamePlaceholder: "Nom d'utilisateur",
    passwordMinPlaceholder: 'Mot de passe (min. 8 caractères)',
    creating: 'Création...',
    createMyAccount: 'Créer mon compte',
  },
  landing: {
    navFeatures: 'Fonctionnalités',
    navHelp: 'Aide',
    ctaStart: 'Commencer',
    heroTitle: 'Commencez à vraiment apprendre',
    heroSubtitle: "Transformez tout en Cartes Mentales. Flashcards. Podcasts. Fiches d'étude, et plus encore. Tout ce dont vous avez besoin — en un seul endroit.",
    startFree: 'Commencer gratuitement →',
    noCreditCard: 'Aucune carte bancaire requise pour le plan gratuit.',
    featuresTitle: 'Tout ce dont vous avez besoin pour maîtriser tous types de documents',
    featuresSubtitle: 'Conçu pour les étudiants, chercheurs et professionnels qui exigent de la précision.',
    feature1Title: 'Extraire les équations',
    feature1Desc: "Importez n'importe quel PDF. Plynote extrait automatiquement toutes les équations, en préservant LaTeX et la notation mathématique.",
    feature2Title: 'Discutez avec vos documents',
    feature2Desc: 'Posez des questions sur les notions ou formules, obtenez des réponses instantanées et explorez des concepts complexes avec votre assistant IA.',
    feature3Title: 'Adaptez à votre style',
    feature3Desc: "Cartes mentales, flashcards, podcasts ou fiches intelligentes. Choisissez comment vous apprenez et retenez l'information.",
    notJustTool1: 'Pas juste un outil de prise de notes.',
    notJustTool2: "C'est un vrai assistant.",
    notJustToolDesc: "C'est un véritable assistant de recherche qui transforme les documents passifs en compréhension active — pour que vous puissiez enfin vous concentrer sur ce qui compte : votre recherche.",
    whyTitle: 'Pourquoi Plynote est meilleur que les autres',
    whySubtitle: 'Plynote se compare aux autres outils de recherche leaders.',
    faqTitle: 'Questions fréquemment posées',
    faqSubtitle: 'Tout ce que vous devez savoir sur Plynote.',
    faq1Q: 'Quels formats de fichiers Plynote supporte-t-il ?',
    faq1A: 'Plynote supporte les formats PDF, DOCX, DOC, TXT, PNG, JPEG, les fichiers audio et les enregistrements audio.',
    faq2Q: 'Plynote extrait-il précisément les équations mathématiques ?',
    faq2A: 'Oui. Plynote est spécifiquement conçu pour reconnaître et extraire les formules mathématiques, physiques, chimiques et statistiques — même dans des PDFs scannés ou des documents complexes.',
    faq3Q: 'Les formules sont-elles préservées lors de la génération de cartes mentales, textes intelligents, audio et flashcards ?',
    faq3A: "Oui. Plynote conserve chaque formule intacte dans tous les formats. La même équation que vous voyez dans l'éditeur apparaît exactement dans votre carte mentale, texte intelligent, résumé audio et flashcards.",
    faq4Q: 'Puis-je utiliser Plynote pour préparer mes cours de tutorat ?',
    faq4A: "Absolument. Plynote génère automatiquement des cartes mentales, flashcards, résumés audio et s'adapte à la mémoire de chaque étudiant.",
    faq5Q: 'Mes documents sont-ils sécurisés ? Que se passe-t-il avec mes données ?',
    faq5A: "Vos documents sont stockés de manière sécurisée. Nous n'utilisons jamais vos données pour entraîner nos modèles IA. Vous pouvez supprimer tous vos documents à tout moment.",
    faq6Q: 'Puis-je utiliser Plynote pour des documents clients confidentiels ?',
    faq6A: "Oui. Plynote respecte votre confidentialité. Aucun document n'est partagé avec des tiers ou utilisé à d'autres fins que votre usage personnel.",
    faq7Q: 'Puis-je annuler à tout moment ?',
    faq7A: "Oui. Vous pouvez annuler votre abonnement à tout moment depuis votre tableau de bord, sans frais d'annulation.",
    faq8Q: "Y a-t-il un essai gratuit ?",
    faq8A: "Oui, et aucune carte bancaire n'est requise.",
    footerProduct: 'Produit',
    footerLegal: 'Légal',
    footerComparative: 'Comparatif',
    footerFeatures: 'Fonctionnalités',
    footerHelp: 'Aide',
    footerPrivacy: 'Politique de confidentialité',
    footerTerms: "Conditions d'utilisation",
    footerSupport: 'Support',
  },
};

export default fr;
